export const environment = {
  BACKEND_URL: 'https://medlaboral.dllosura.com/bandejamedlaboral/v1',
  production: false,
};
